import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { publicadosSelector } from "../../selectors/catalogoSelector";
import * as catalogoActions from "../../reducers/catalogoReducer/actions";
import DialogPublicados from "../../components/Catalogo/dialogPublicados";

class DialogPublicadosContainer extends React.Component {
  constructor(props) {
    super(props);

    this.props.sagaGetPublicados();

    this.state = {
      selectedIndexPublicados: 1,
    };
  }

  UNSAFE_componentWillReceiveProps() {
    if (this.props.dataPublicados.data.length > 0) {
      this.setState({
        selectedIndexPublicados: this.props.dataPublicados.data[0].idCatalogo,
      });
    }
  }

  handleChangePublicados = (e) => {
    let state = { ...this.state };
    state.selectedIndexPublicados = e.target.value;
    this.setState({
      selectedIndexPublicados: state.selectedIndexPublicados,
    });
  };

  render() {
    return (
      <div>
        <DialogPublicados
          publicados={this.props.dataPublicados.data}
          handleChangePublicados={this.handleChangePublicados}
          selectedIndexPublicados={this.state.selectedIndexPublicados}
          handleCancelButton={this.props.handleCancelPublicadosDialog}
          handleOnTrasladar={() =>
            this.props.handleOnTrasladar(
              this.props.catalogo.idCatalogo,
              this.state.selectedIndexPublicados
            )
          }
          catalogo={this.props.catalogo}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...catalogoActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    dataPublicados: publicadosSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogPublicadosContainer);
